import { Business_Profile_Enum, Maybe, Order, Order_Status_Enum, Staff_User } from '@kheops/graphql';
import { OrderStatusTypeIntl } from '../i18n/order-status.translation';

type SuggestedByStaffOrder = Pick<Order, 'suggestor_id'> & {
  suggestor?: Maybe<{ staff_user?: Maybe<Pick<Staff_User, 'role'>> }>;
};

export function isOrderSuggestedByStaff(order: SuggestedByStaffOrder): boolean {
  return !!order.suggestor_id && !!order.suggestor?.staff_user?.role;
}

export function getOrderStatusIntl(status: Order_Status_Enum, realm: Business_Profile_Enum): string {
  const statusToMap = status === Order_Status_Enum.OrderToBePreparedBySupplier && realm === Business_Profile_Enum.Buyer
    ? Order_Status_Enum.OrderToBeDeliveredBySupplier
    : status;

  return OrderStatusTypeIntl[realm][statusToMap];
}
